import { t, QueryFormData } from '@superset-ui/core';
import {
  ControlPanelConfig,
  sections,
  sharedControls,
} from '@superset-ui/chart-controls';
import ColorMapControl from './ColorMapControl';

const config = {
  controlPanelSections: [
    sections.legacyTimeseriesTime,
    {
      label: t('Query'),
      expanded: true,
      controlSetRows: [
        [
          {
            name: 'categoryColumn',
            config: {
              type: 'SelectControl',
              label: t('Category Column'),
              description: t('Kolom yang akan ditampilkan'),
              default: [],
              multiple: true,
              clearable: true,
              mapStateToProps: (state: any) => ({
                choices: (state.datasource?.columns || []).map((c: any) => [
                  c.column_name,
                  c.column_name,
                ]),
              }),
            },
          },
        ],
        ['series_columns'],
        ['adhoc_filters'],
      ],
    },
    {
      label: t('Chart Properties'),
      expanded: true,
      controlSetRows: [
        [
          {
            name: 'raising_value',
            config: {
              type: 'TextControl',
              label: t('Raising Value'),
              default: '1',
              description: t('Raising Value'),
            },
          },
          {
            name: 'falling_value',
            config: {
              type: 'TextControl',
              label: t('Falling Value'),
              default: '0',
              description: t('Falling Value'),
            },
          },
        ],
        [
          {
            name: 'orientation',
            config: {
              type: 'SelectControl',
              label: t('Orientation'),
              default: 'horizontal',
              multiple: false,
              clearable: false,
              choices: [
                ['vertical', t('Vertical')],
                ['horizontal', t('Horizontal')],
              ],
              description: t('Orientation of the chart'),
            },
          },
        ],
        [
          {
            name: 'colorMapping',
            config: {
              type: 'CustomControl',
              label: t('React Component'),
              description: t('React Component'),
              defaultValue: [
                { category: 'Running', color: '#008000' },
                { category: 'Stop', color: '#FF0000' },
                { category: 'Idle', color: '#FFFF00' },
                { category: 'Rest', color: '#0000FF' },
              ],
              component: ColorMapControl,
            },
          },
        ],
      ],
    },
  ],
  controlOverrides: {
    groupby: {
      default: [], // Kosongkan default value
      description: t('Group By telah dinonaktifkan untuk chart ini.'),
    },
  },
};

export default config;
